<template>
	<div class="slb-detail-container init">
		<div class="cps-page-top">
			<!--头部-->
			<div class="jc-page-header">
				<el-page-header show-back-icon :title="$t('slb.text.slb')" @back="jumpToUp()" class="relative">
					<template slot="content">
						<span class="long-name" :title="slbDetail.name">
							{{ slbDetail.name }}
						</span>
						<div class="jc-list__header--right jc-box-action">
							<!--帮助文档-->
							<a v-bind:href="Config.SLB_HELP_URL" target="_blank">
								{{ $t('slb.text.slbHelpDoc') }}
							</a>
							<!--操作-->
							<drop-down-operation :operations="operates" @clickSelectItem="afterSelectOps"
								:buttonTitle="$t('privateNetwork.operate')">
							</drop-down-operation>
						</div>
					</template>
				</el-page-header>
			</div>
			<!--内容-->
			<div class="jc-page-content">
				<el-tabs type="border-card" @tab-click="handleTabClick" v-model="activeTabName"
					v-bind:class="{ 'dark-gray-background': darkLoaded }">
					<!--资源信息-->
					<el-tab-pane :label="$t('detail.text.sourceInfo')" name="baseInfo">
						<!--基本信息-->
						<div class="jc-section">
							<div class="jc-section-header">
								<h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
							</div>
							<div class="jc-section-content">
								<el-form class="base-info-list" @submit.stop.prevent v-if="activeTabName ===
									'baseInfo'">
									<el-row :gutter="20">
										<el-col :span="8">
											<el-form-item :label="$t('slb.text.id') | withColon">
												<p>
													<span>{{ slbDetail.loadBalancerId }}</span>
                          <copy-value :copyVal="`${slbDetail.loadBalancerId}`"></copy-value>
													<!-- <el-tooltip :content="$t('privateNetwork.copySuccess')" effect="dark"
														placement="bottom" :disabled="!copyHover" class="tooltip-item">
														<span @mouseout="copyHover = false">
															<el-button type="text" icon="el-icon-document-copy"
																v-clipboard:copy="slbDetail.loadBalancerId"
																v-clipboard:success="onCopy"
																v-clipboard:error="onError"></el-button>
														</span>
													</el-tooltip> -->
												</p>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('slb.text.slbName') | withColon">
												<span :title="slbDetail.name">{{ slbDetail.name }}</span>
												<el-popover ref="editValue" trigger="click" :visible-arrow="false"
													:offset="0" placement="left-start" :width="300" v-if="showEditName"
													:value="showEditName">
													<edit-value :inputVal="slbDetail.name" v-if="showEditName"
														:inputValRule="rules.name" @sureEdit="handleEditName"
														:popTitle="$t('privateNetwork.editName')"
														:showEditDes.sync="showEditName" :isLbEdit="true"
														:region="region"></edit-value>
												</el-popover>
												<el-button type="text" icon="jc-icon-edit" @click="showEditName = true"
													v-popover:editValue>
												</el-button>
												<div class="jc-colude-mask" v-if="showEditName"></div>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('slb.text.description') | withColon"
												class="edit-jc-form">
												<span :title="slbDetail.description">
													{{ slbDetail.description }}
												</span>
												<el-popover ref="editDes" trigger="click" :visible-arrow="false" :offset="0"
													placement="left-start" :width="300" v-if="showEditDes"
													:value="showEditDes">
													<edit-value :inputVal="slbDetail.description" v-if="showEditDes"
														:inputValRule="rules.description" @sureEdit="handleEditDes"
														:type="'textarea'" :popTitle="$t('privateNetwork.editDescription')"
														:showEditDes.sync="showEditDes"></edit-value>
												</el-popover>
												<el-button type="text" icon="jc-icon-edit" @click="showEditDes = true"
													v-popover:editDes>
												</el-button>
												<div class="jc-colude-mask" v-if="showEditDes"></div>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.region') | withColon">
												<span>{{ transformRegion(slbDetail.region) }}</span>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.availableArea') | withColon">
												<span>{{ transformAz(slbDetail.az) }}</span>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('listPage.text.tags') | withColon"
												class="edit-jc-form">
												<span class="instance-name" :title="slbDetail.tagPairs">{{
													slbDetail.tagPairs
													| maybeEmpty }}</span>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
						</div>
						<el-divider></el-divider>
						<!-- 计费信息 -->
						<div class="jc-section">
							<div class="jc-section-header">
								<h3 class="jc-section-title">{{ $t('list.chargeInfo') }}</h3>
							</div>
							<div class="jc-section-content">
								<el-form class="base-info-list" @submit.stop.prevent v-if="activeTabName ===
									'baseInfo'">
									<el-row :gutter="20">
										<!--计费类型-->
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.billingType') | withColon">
												<span>{{ transformChargeMode(slbChargeDetail.chargeMode) }}</span>
											</el-form-item>
										</el-col>
										<!-- 创建时间 -->
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.createTime') | withColon">
												<span>{{ transformTime(slbDetail.createTime) }}</span>
											</el-form-item>
										</el-col>
										<!--到期时间-->
										<el-col v-if="slbChargeDetail.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION"
											:span="8">
											<el-form-item :label="$t('detail.text.expireTime') | withColon">
												<span>{{ transformTime(slbChargeDetail.chargeExpiredTime) }}</span>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
						</div>
						<el-divider></el-divider>
						<!--网络信息-->
						<div class="jc-section">
							<div class="jc-section-header">
								<h3 class="jc-section-title">{{ $t('detail.text.netInfo') }}</h3>
							</div>
							<div class="jc-section-content">
								<el-form class="net-info-list" @submit.stop.prevent>
									<el-row :gutter="20">
										<el-col :span="8">
											<el-form-item :label="$t('privateNetInstance.networkType') | withColon">
												{{ transformNetType(slbDetail.netType) }}
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('slb.text.ipVersion') | withColon">
												<span>{{ transformIpVersion(slbDetail.ipAddressType) }}</span>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('slb.text.privateNetwork') | withColon">
												<a href="javascript:void(0)"
													@click="jumpToVpcDetail(slbDetail.vpcId, slbDetail.region, slbDetail.vpcName)">
													{{ slbDetail.vpcName }}
												</a>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('slb.text.bindServerType') | withColon">
												<span>{{ $t('slb.text.cps') }}</span>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('slb.text.publicNet') | withColon('IPv4:')">
												<span v-if="slbDetail.elasticIpId">
													<a href="javascript:void(0)"
														@click="jumpToEip(slbDetail.elasticIpId, slbDetail.region)">
														{{ slbDetail.publicIp }}
													</a>
												</span>
												<span v-else>--</span>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('slb.text.publicNetBandwidth') | withColon">
												<span v-if="slbDetail.bandwidth">
													{{ String(slbDetail.bandwidth) | withColon('Mbps') }}
												</span>
												<span v-else>--</span>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
						</div>
					</el-tab-pane>
					<!--监听器-->
					<el-tab-pane :label="$t('slb.text.listener')" name="listenerList" class="listener-list">
						<div class="jc-container-table">
							<div class="jc-container-table-actionBar">
								<el-form class="jc-table-actionBar-item" :inline="true">
									<!--刷新-->
									<el-form-item>
										<el-button icon="jc-icon-refresh-line" class="jc-button-icon"
											@click="updateListenerList">
										</el-button>
									</el-form-item>
									<!--创建监听器-->
									<el-form-item>
										<el-tooltip
											:disabled="this.slbChargeDetail.chargeStatus && !this.disableByChargeStatus"
											:content="!slbChargeDetail.chargeStatus ? $t('eip.help.noChargeInfo') : this.disableByChargeStatus ? $t('privateNetInstance.operations.overdueTip') : $t('slb.sentence.moreThan50')"
											placement="bottom" effect="dark">
											<label>
												<el-button type="primary" @click="jumpToListenerCreate()"
													:disabled="!this.slbChargeDetail.chargeStatus || this.disableByChargeStatus">
													{{ $t('slb.text.createListener') }}
												</el-button>
											</label>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
							<el-table :data="listenerListData" style="width: 100%"
								class="jc-list-table jc-table-header-cell" v-loading="listenerRefreshLoading"
								ref="listTable" :empty-text="$t('speechCraft.listEmptyText')">
								<!--名称-->
								<el-table-column :label="$t('slb.text.name')" min-width="120" prop="name">
									<template slot-scope="scope">
										<el-tooltip class="item" effect="dark" :content="scope.row.name" placement="bottom">
											<a href="javascript:void(0)"
												@click="jumpToListenerDetail(scope.row.listenerId)">
												{{ scope.row.name | maybeEmpty }}
											</a>
										</el-tooltip>
									</template>
								</el-table-column>
								<!--监听协议：端口-->
								<el-table-column :label="$t('slb.text.protocolPort')" min-width="120" prop="protocol">
									<template slot-scope="scope">
										<span>{{ scope.row.protocol + ':' + scope.row.port }}</span>
									</template>
								</el-table-column>
								<!--状态-->
								<el-table-column prop="status" min-width="85" :label="$t('detail.text.status')">
									<template slot-scope="scope">
										<span>{{ scope.row.statusName | maybeEmpty }}</span>
									</template>
								</el-table-column>
								<!--会话保持-->
								<el-table-column prop="stickySession" min-width="100" key="networkTypeName"
									:label="$t('slb.text.stickySession')">
									<template slot-scope="scope">
										<span>
											{{ scope.row.stickySessionName | maybeEmpty }}
										</span>
									</template>
								</el-table-column>
								<!--调度算法-->
								<el-table-column :label="$t('slb.text.algorithm')" min-width="120" prop="algorithm">
									<template slot-scope="scope">
										<p>
											{{ scope.row.algorithmName | maybeEmpty }}
										</p>
									</template>
								</el-table-column>
								<!--健康检查-->
								<el-table-column prop="healthCheck" :label="$t('slb.text.healthCheck')" min-width="120">
									<template slot-scope="scope">
										<span>
											{{ scope.row.healthCheckName | maybeEmpty }}
										</span>
									</template>
								</el-table-column>
								<!--后端服务器组-->
								<el-table-column min-width="115" prop="serverGroupName"
									:label="$t('slb.text.backendServerGroups')">
									<template slot-scope="scope">
										<el-tooltip class="item" effect="dark" :content="scope.row.serverGroupName"
											placement="bottom">
											<a href="javascript:void(0)" @click="openServerGroupTab(scope.row)">
												{{ scope.row.serverGroupName | maybeEmpty }}
											</a>
										</el-tooltip>
									</template>
								</el-table-column>
								<!--操作-->
								<el-table-column prop="operation" min-width="150"
									:label="$t('listPage.tableLabel.operation')">
									<template slot-scope="scope">
										<!--编辑-->
										<a class="cps-select-form-item" href="javascript:void(0)"
											@click="selectOps(OperationConstant.EDIT, scope.row)">
											{{ $t('slb.text.edit') }}
										</a>
										<el-dropdown @command="(command) => handleCommand(command, scope.row)">
											<span class="jc-dropdown-link">
												{{ $t('operations.more') }}<i
													class="jc-icon-caret-bottom jc-icon--right"></i>
											</span>
											<el-dropdown-menu slot="dropdown" class="operation-list-dropdown-menu">
												<!--开启-->
												<el-dropdown-item v-if="scope.row.status === 'inactive'" command="opened">
													{{ $t('slb.text.opened') }}
												</el-dropdown-item>
												<!--关闭-->
												<el-dropdown-item v-if="scope.row.status === 'active'" command="closed">
													{{ $t('slb.text.closed') }}
												</el-dropdown-item>
												<!--SNI管理-->
												<el-dropdown-item v-if="scope.row.protocol.toLocaleUpperCase() === 'HTTPS'"
													command="sni">
													{{ $t('slb.text.sni') }}
												</el-dropdown-item>
												<!--删除-->
												<el-dropdown-item command="delete">
													{{ $t('subnet.text.delete') }}
												</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-tab-pane>
					<!--虚拟服务器组-->
					<el-tab-pane :label="$t('slb.serverGroup.virtualServerGroup')" name="defaultServerGroup"
						class="listener-list">
						<div class="jc-container-table">
							<div class="jc-container-table-actionBar">
								<el-form class="jc-table-actionBar-item" :inline="true">
									<!--刷新-->
									<el-form-item>
										<el-button icon="jc-icon-refresh-line" class="jc-button-icon" @click="iconClick">
										</el-button>
									</el-form-item>
									<!--创建服务器组-->
									<el-form-item>
										<el-tooltip
											:content="!slbChargeDetail.chargeStatus ? $t('eip.help.noChargeInfo') : this.disableByChargeStatus ? $t('privateNetInstance.operations.overdueTip') : $t('slb.tooltip.countLimit')"
											placement="bottom"
											:disabled="this.slbChargeDetail.chargeStatus && !this.disableByChargeStatus">
											<label>
												<el-button type="primary" @click="jumpToServerGroupAdd()"
													:disabled="!this.slbChargeDetail.chargeStatus || this.disableByChargeStatus">
													{{ $t('slb.serverGroup.addVirtualServerGroup') }}
												</el-button>
											</label>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
							<el-table :data="serverGroupList" style="width: 100%"
								:empty-text="$t('speechCraft.listEmptyText')" v-loading="serversGroupLoading">
								<el-table-column :label="$t('slb.serverGroup.virtualServerGroup')">
									<template slot-scope="scope">
										<a href="javascript:void(0)" @click="jumpToServerDetail(scope.row)">
											{{ scope.row.name }}
										</a>
									</template>
								</el-table-column>
								<el-table-column :label="$t('slb.serverGroup.sourceCount')" prop="counts">
								</el-table-column>
								<el-table-column :label="$t('slb.serverGroup.operate')">
									<template slot-scope="scope">
										<el-button type="text" @click="openEditWeight(scope.row)">
											{{ $t('slb.text.edit') }}
										</el-button>
										<el-button type="text" @click="openDelete(scope.row)">
											{{ $t('slb.text.delete') }}
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<!--分页-->
		<div ref="footer" class="cps-page-footer block jc-container-table-actionBar"
			v-if="total > 0 && activeTabName !== 'baseInfo'">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				:page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
		<!--点击添加时调用-->
		<add-server :visible.sync="isAddServer" v-if="isAddServer" @handleClickAdd="afterClickAdd" :operationType="'add'"
			:region="region" :title="$t('slb.serverGroup.addVirtualServerGroup')" :loadBalancerId="loadBalancerId"
			:slbVpcName="slbDetail.vpcName">
		</add-server>
		<!--点击编辑时调用-->
		<add-server :visible.sync="isEditServer" v-if="isEditServer" @handleClickAdd="afterClickAdd" :operationType="'edit'"
			:region="region" :title="$t('slb.serverGroup.editVirtualServerGroup')" :rowInfo="currentRow"
			:loadBalancerId="loadBalancerId" :slbVpcName="slbDetail.vpcName">
		</add-server>
		<!--点击绑定弹性公网时调用-->
		<bind-flex-net :visible.sync="bindShow" v-if="bindShow" :region="this.region" :alert="false" :isSlb="true"
			:loadBalancerId="loadBalancerId" :instanceName="slbDetail.name" @refresh="getSlbDetail">
		</bind-flex-net>
		<!-- 编辑标签 -->
		<jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPSLB"
			:region-id="slbDetail.region ? slbDetail.region : ''"
			:resource-ids="slbDetail.loadBalancerId ? [slbDetail.loadBalancerId] : []" @complete="getSlbDetail">
		</jcb-tag-edit>
		<!--删除SLB组件-->
		<delete-listener :dialogVisible="deleteListenerVisible" :params="deleteListenerData"
			@refreshList="updateListenerList" @ifDialogVisible="syncBindDialog">
		</delete-listener>
		<!--删除slb-->
		<delete-slb :visible.sync="deleteSlbVisible" @refresh="goBack" :rowInfo="slbDetail" :pageSource="'detail'">
		</delete-slb>
	</div>
</template>

<script>
import { transformIpType } from '@/common/tool';
import {
	RegionMap,
	AlgorithmNameMapConstant,
	OnOrOffMapConstant,
	RunningOrStoppedConstant,
	ServiceCodeConstant,
	OverdueConstantArray,
	ListenerOperationConstant,
	ChargeModeConstant,
	ArrearConstantArray
} from '@/common/Constants';
import { operations } from '@/common/ListenerPopHelper';
import addServer from '@/components/slb/detail/defaultServerGroup/Addserver';
import { remove_virtual_servers } from '@/common/SlbPopHelper';
import DeleteListener from '@/components/slb/detail/listener/delete/Delete';
import editValue from '@/components/privateNetwork/EditValue';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import { operations as slbOperatios } from '@/common/SlbPopHelper';
import { SlbOperationConstant } from '@/common/Constants';
import { getYMD } from '@/common/dataHelper';
import bindFlexNet from '@/components/privateNetInstance/bindFlexNet/BindFlexNet';
import DeleteSlb from '@/components/common/DeleteSlb';
import copyValue from '@/components/privateNetwork/CopyValue';
export default {
	components: {
		addServer,
		DeleteListener,
		editValue,
		dropDownOperation,
		bindFlexNet,
		DeleteSlb,
		copyValue
	},
	data() {
		const OperationConstant = {
			'EDIT': 1,
			'OPEN': 2,
			'CLOSE': 3,
			'DELETE': 4
		};
		const valName = (rule, value, callback) => {
			const nameRule = /^[-0-9a-zA-Z_\u4e00-\u9fa5]{1,32}$/;
			if (!value) {
				callback(new Error(this.$t('privateNetwork.nameNotNull')));
			} else if (!nameRule.test(value)) {
				callback(new Error(this.$t('privateNetwork.nameHelp')));
			} else {
				callback();
			}
		};
		const valDes = (rule, value, callback) => {
			if (value.length > 256) {
				callback(new Error(this.$t('detail.speechCraft.descriptionLongRule')));
			} else {
				callback();
			}
		};
		return {
			// 转换地域显示
			slbRegions: {},
			// 显示绑定弹性公网IP弹框
			bindShow: false,
			// 下拉操作
			operates: [],
			// 编辑姓名和描述规则
			rules: {
				name: [
					{
						validator: valName,
					}
				],
				description: [
					{
						validator: valDes,
					}
				]
			},
			// 显示编辑描述弹窗
			showEditDes: false,
			// 显示编辑姓名弹窗
			showEditName: false,
			// 复制成功提示
			copyHover: false,
			// 负载均衡实例详情
			slbDetail: {},
			// 负载均衡charge信息
			slbChargeDetail: {},
			// 虚拟服务器组表格Loading
			serversGroupLoading: false,
			// 增加虚拟服务器组弹框显隐
			isAddServer: false,
			// 编辑虚拟服务器组弹框显隐
			isEditServer: false,
			// 获取的过滤值
			serverGroupFilters: {
				azs: [],
				status: []
			},
			// 选定的过滤值
			serverGroupFilterParams: {
				az: '',
				status: ''
			},
			// 当前操作行
			currentRow: {},
			serverGroupList: [],
			clientToken: Normal.getClientToken(),
			gridData: {},
			region: '',
			loadBalancerId: '',
			// 列表中数据个数
			total: 0,
			// 监听器的数量
			listenerCount: 0,
			// 监听器的协议类型
			listenerProtocolType: "11",
			// 当前激活的tab标签页
			activeTabName: 'baseInfo',
			// 是否需要装载深色背景
			darkLoaded: false,
			// 每一页多少条
			pageSize: 20,
			// 可选每页展示多少条,
			pageSizes: [20, 50, 100],
			// 当前的页数
			currentPage: 1,
			/** ****************监听器相关 START***************** */
			// SLB对应的监听器列表
			listenerListData: [],
			// SLB列表loading
			listenerRefreshLoading: false,
			// 监听器支持的三个操作
			OperationConstant,
			// 编辑标签组件是否显示
			editTagDialogVisible: false,
			// 删除监听器弹框是否可见
			deleteListenerVisible: false,
			deleteListenerData: {},
			/** ****************监听器相关 END***************** */
			deleteSlbVisible: false
		};
	},
	computed: {
		RegionMap: () => RegionMap,
		AlgorithmNameMapConstant: () => AlgorithmNameMapConstant,
		ServiceCodeConstant: () => ServiceCodeConstant,
		OnOrOffMapConstant: () => OnOrOffMapConstant,
		OverdueConstantArray: () => OverdueConstantArray,
		RunningOrStoppedConstant: () => RunningOrStoppedConstant,
		ArrearConstantArray: () => ArrearConstantArray,
		/**
		 * 判断同一个负载均衡实例下
		 * 虚拟服务器组个数是否超过50
		 */
		serverGroupNumbersOverLimit() {
			return this.total >= 50;
		},
		// 判断操作是否应该因不正确的计费状态而被禁用
		disableByChargeStatus() {
			if (OverdueConstantArray.includes(this.slbChargeDetail.chargeStatus)) {
				return true;
			}
			return false;
		},
		ChargeModeConstant: () => ChargeModeConstant
	},
	mounted() {
		this.region = this.$route.query.region;
		this.activeTabName = this.$route.query.activeTabName;
		this.loadBalancerId = this.$route.query.loadBalancerId;
		// 获取资源信息tab页数据
		this.getDifferentDataByTab();
	},
	watch: {
		activeTabName() {
			this.getDifferentDataByTab();
		}
	},
	methods: {
		/**
		 * 转化IP版本显示
		 * @param ipType
		 * @return String
		 */
		transformIpVersion(ipType) {
			return transformIpType(ipType)
		},
		/**
		 * 转换地域显示
		 * @param region
		 * @return String
		 */
		transformRegion(region) {
			return this.slbRegions[region];
		},
		/**
		 * 获得地域显示转换
		 */
		getRegions() {
			Ajax.get('api/cps/cpslbRegions')
				.then((res) => {
					const target = this;
					res.data.regions.forEach((region) => {
						target.slbRegions[region.region] = region.regionName;
					});
				});
		},
		/**
		 * 跳转公网ip资源详情
		 */
		jumpToEip(id, region) {
			this.$router.push({
				path: `/eip/detail/${id}/${region}`,
			});
		},
		/**
		 * 跳转私有网络详情资源信息tab
		 * @param id
		 * @param region
		 * @param name
		 */
		jumpToVpcDetail(id, region, name) {
			this.$router.push(
				{
					path: '/vpc/detail',
					query: {
						id,
						region,
						tabName: 'source',
						vpcName: name
					}
				}
			);
		},
		/**
		 * 转换网络类型显示
		 * @param type
		 * @return String
		 */
		transformNetType(type) {
			switch (type) {
				case 'public':
					return this.$t('slb.text.publicNet');
				default:
					return type;
			}
		},
		/**
		 * 转化时间显示格式
		 * @param time
		 * @return String
		 */
		transformTime(time) {
			if (typeof time === 'undefined') {
				return '';
			}
			return getYMD(new Date(time));
		},
		/**
		 * 转化计费类型显示
		 * 目前只返回包年包月
		 */
		transformChargeMode(type) {
			switch (type) {
				case 'postpaid_by_duration':
					return this.$t('listPage.text.postpaid_by_duration');
					break;
				default:
					return this.$t('privateNetInstance.monthAndYear');
					break;
			}
		},
		/**
		 * 转化可用区显示
		 * 根据交互可用区全部展示为全可用区
		 */
		transformAz(az) {
			switch (az) {
				default:
					return this.$t('slb.text.allAz');
			}
		},
		/**
		 * 跟据不同操作类型调用SlbOperations
		 */
		afterSelectOps(item) {
			let operationType;
			if (item === 'bind') {
				this.bindShow = true;
			} else {
				switch (item) {
					case 'add':
						this.activeTabName = 'listenerList';
						break;
					case 'renew':
						operationType = SlbOperationConstant.RENEW;
						break;
					case 'open':
						operationType = SlbOperationConstant.OPEN;
						break;
					case 'close':
						operationType = SlbOperationConstant.CLOSE;
						break;
					case 'unbind':
						operationType = SlbOperationConstant.UNBIND;
						break;
					case 'editTag':
						operationType = SlbOperationConstant.EDITTAG;
						break;
					case 'delete':
						operationType = SlbOperationConstant.DELETE;
						break;
					default:
				}
				slbOperatios(operationType, this, this.slbDetail, 'detail');
			}
		},
		/**
		 * 操作下拉选初始化，绑定、解绑、调整带宽、续费、删除
		 */
		initOperates() {
			const tempOperations = [
				{
					operateName: this.$t('slb.text.addListener'),
					disabled: !this.slbChargeDetail.chargeStatus || this.disableByChargeStatus,
					value: 'add',
					tip: !this.slbChargeDetail.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.disableByChargeStatus ? this.$t('privateNetInstance.operations.overdueTip') : '',
				},
				{
					operateName: this.$t('slb.text.renew'),
					disabled: !this.slbChargeDetail.chargeStatus,
					value: 'renew',
					tip: !this.slbChargeDetail.chargeStatus ? this.$t('eip.help.noChargeInfo') : '',
				},
				{
					operateName: this.$t('operations.edit_tag.name'),
					disabled: !this.slbChargeDetail.chargeStatus,
					value: 'editTag',
					tip: !this.slbChargeDetail.chargeStatus ? this.$t('eip.help.noChargeInfo') : '',
				},
				{
					operateName: this.$t('slb.text.delete'),
					disabled: this.slbChargeDetail.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION || this.slbChargeDetail.chargeStatus === undefined || this.slbDetail.status === 'active',
					tip: !this.slbChargeDetail.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.slbChargeDetail.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION ? this.$t('operations.delete.tip') : '',
					value: 'delete',
				}
			];
			if (typeof this.slbDetail.elasticIpId !== 'undefined') {
				tempOperations.splice(1, 0, {
					operateName: this.$t('slb.text.unbindPublicIp'),
					disabled: !this.slbChargeDetail.chargeStatus || this.disableByChargeStatus,
					value: 'unbind',
					tip: !this.slbChargeDetail.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.disableByChargeStatus ? this.$t('privateNetInstance.operations.overdueTip') : '',
				});
			} else {
				tempOperations.splice(1, 0, {
					operateName: this.$t('slb.text.bindPublicIp'),
					disabled: !this.slbChargeDetail.chargeStatus || this.disableByChargeStatus,
					value: 'bind',
					tip: !this.slbChargeDetail.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.disableByChargeStatus ? this.$t('privateNetInstance.operations.overdueTip') : '',
				});
			}
			if (this.slbDetail.status === 'active') {
				tempOperations.splice(2, 0, {
					operateName: this.$t('slb.text.closed'),
					disabled: !this.slbChargeDetail.chargeStatus || this.disableByChargeStatus,
					value: 'close',
					tip: !this.slbChargeDetail.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.disableByChargeStatus ? this.$t('privateNetInstance.operations.overdueTip') : '',
				});
			} else {
				tempOperations.splice(2, 0, {
					operateName: this.$t('slb.text.opened'),
					disabled: typeof this.slbDetail.elasticIpId === 'undefined' || !this.slbChargeDetail.chargeStatus || this.disableByChargeStatus,
					value: 'open',
					tip: !this.slbChargeDetail.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.disableByChargeStatus ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('slb.sentence.bindEipNecessary'),
				});
			}
			this.operates = tempOperations;
		},
		/**
		 * 编辑负载均衡实例
		 */
		editSlb(params) {
			const defaultParams = {
				region: this.region,
				loadBalancerId: this.loadBalancerId
			};
			const realParams = Object.assign({}, defaultParams, params);
			Ajax.post('/api/cps/slbs', realParams)
				.then((res) => {
					this.slbDetail = Object.assign({}, this.slbDetail, res.data.loadBalancer);
				})
				.catch()
				.finally(() => {
					this.getSlbDetail();
				});
		},
		/**
		 * 修改负载均衡实例名称
		 */
		handleEditName(name) {
			const params = {
				name
			};
			this.editSlb(params);
		},
		/**
		 * 修改负载均衡实例描述
		 */
		handleEditDes(description) {
			const params = {
				description
			};
			this.editSlb(params);
		},
		/**
		 * 复制成功时
		 */
		onCopy() {
			this.copyHover = true;
		},
		/**
		 * 复制失败时
		 */
		onError() { },
		/**
		 * 获取负载均衡实例详情
		 */
		getSlbDetail() {
			const params = {
				region: this.region,
				loadBalancerId: this.loadBalancerId
			};
			Ajax.get('/api/cps/slbs', params)
				.then((res) => {
					this.slbDetail = res.data.loadBalancer;
					this.slbChargeDetail = res.data.loadBalancer.charge;
					const tagPairs = res.data.loadBalancer.tags;
					this.slbDetail.tagPairs = '';
					if (tagPairs && tagPairs.length) {
						for (const tag of tagPairs) {
							this.slbDetail.tagPairs += `${tag.key}:${tag.value},`;
						}
						this.slbDetail.tagPairs = this.slbDetail.tagPairs.substring(0, this.slbDetail.tagPairs.length - 1)
					}
				})
				.catch()
				.finally(() => {
					this.initOperates();
				});
		},
		/**
		 * 编辑虚拟服务器组
		 * @param name
		 * @param servers
		 * @param serverGroupId
		 * @param deleteList
		 */
		editServerGroups(name, servers, serverGroupId, deleteList) {
			const update = servers.map(server => {
				if (server.iptype) {
					if (server.iptype === '0') {
						server.rip = server.selectedIpAddress
					} else {
						server.aliasip = server.selectedIpAddress
					}
				} else {
					if (server.selectedIpAddress === server.privateIp || server.selectedIpAddress === server.extensionPrivateIp) {
						server.rip = server.selectedIpAddress
					} else {
						server.aliasip = server.selectedIpAddress
					}
				}
				return {
					instanceId: server.instanceId,
					port: server.port.toString(),
					weight: server.weight.toString(),
					serverId: typeof server.serverId === 'undefined' ? null : server.serverId,
					action: 'update',
					nicMode: server.interfaceMode || server.nicMode,
					interfaceName: server.interfaceName,
					rip: server.rip,
					aliasip: server.aliasip
				}
			});
			deleteList = deleteList.map(server => ({
				instanceId: server.instanceId,
				port: server.port.toString(),
				weight: server.weight.toString(),
				serverId: server.serverId,
				action: 'delete',
				nicMode: server.interfaceMode || server.nicMode,
				interfaceName: server.interfaceName,
				rip: server.iptype === '0' ? server.selectedIpAddress : '',
				aliasip: server.iptype === '1' ? server.selectedIpAddress : ''
			}));
			const serverSpec = update.concat(deleteList)
			const params = {
				region: this.region,
				loadBalancerId: this.loadBalancerId,
				clientToken: Normal.getClientToken(),
				name,
				serverGroupId,
				serverSpec
			};
			Ajax.post('api/cps/serverGroups', params, {
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(() => {
			}).catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			}).finally(() => {
				const refreshParams = {
					pageSize: 20,
					pageNumber: 1
				};
				this.refreshGroupList(refreshParams);
			});
		},
		/**
		 * 增加虚拟服务器组
		 * @param name
		 * @param servers
		 */
		addServerGroups(name, servers) {
			let serverSpec = [];
			if (servers.length !== 0) {
				serverSpec = servers.map(server => ({
					instanceId: server.instanceId,
					port: server.port.toString(),
					weight: server.weight.toString(),
					nicMode: server.interfaceMode,
					interfaceName: server.interfaceName,
					rip: (server.selectedIpAddress === server.privateIp || server.selectedIpAddress === server.extensionPrivateIp) ? server.selectedIpAddress : '',
					aliasip: (server.selectedIpAddress !== server.privateIp && server.selectedIpAddress !== server.extensionPrivateIp) ? server.selectedIpAddress : ''
				}));
			}
			const params = {
				region: this.region,
				loadBalancerId: this.loadBalancerId,
				clientToken: Normal.getClientToken(),
				name,
				serverSpec
			};
			Ajax.put('/api/cps/serverGroups', params, {
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(() => {

			}).catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			}).finally(() => {
				const refreshParams = {
					pageSize: 20,
					pageNumber: 1
				};
				this.refreshGroupList(refreshParams);
			});
		},
		/**
		 * 虚拟服务器组点击确定后回调
		 * @param serverGroupName
		 * @param chosenList
		 * @param operationType
		 * @param serverGroupId // 编辑时使用
		 * @param deleteList // 编辑时调用
		 */
		afterClickAdd(serverGroupName, chosenList, operationType, serverGroupId, deleteList) {
			if (operationType === 'add') {
				this.addServerGroups(serverGroupName, chosenList);
			} else {
				this.editServerGroups(serverGroupName, chosenList, serverGroupId, deleteList);
			}
		},
		/**
		 * 点击跳转服务器组详情
		 * @param row
		 */
		jumpToServerDetail(row) {
			this.$router.push({
				path: '/lb/server/detail',
				query: {
					region: this.region,
					groupName: row.name,
					serverGroupId: row.serverGroupId,
					loadBalancerId: row.loadBalancerId,
					slbVpcName: this.slbDetail.vpcName
				}
			});
		},
		/**
			* 编辑成功后回调
		*/
		afterEdit() {
			this.refreshGroupList({});
		},
		/**
			* 点击刷新图标时
		*/
		iconClick() {
			const params = {
				pageSize: this.pageSize,
				pageNumber: this.currentPage
			};
			this.refreshGroupList(params);
		},
		/**
			* 打开编辑虚拟服务器组窗口
			* @param row
		*/
		openEditWeight(row) {
			this.currentRow = row;
			this.isEditServer = true;
		},
		/**
			* 打开删除窗口
			* @param row
		*/
		openDelete(row) {
			console.log(row, 'del--info');
			row.region = this.region;
			remove_virtual_servers(this, row, 'list');
		},
		/**
			* 刷新列表
			* @param params
		*/
		refreshGroupList(params) {
			const defaultParams = {
				region: this.region,
				pageSize: this.pageSize,
				pageNumber: this.currentPage,
				loadBalancerId: this.loadBalancerId
			};
			const realParams = Object.assign({}, defaultParams, params);
			this.getVirtualServerGroupList(realParams);
		},
		/**
			* 获取虚拟服务器组列表
			* @param params
		*/
		getVirtualServerGroupList(params) {
			this.getSlbDetail();
			this.serversGroupLoading = true;
			Ajax.get('/api/cps/listServerGroups', params)
				.then((res) => {
					if (res.data) {
						this.serverGroupList = res.data.serverGroups;
						this.total = res.data.totalCount;
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
					this.serversGroupLoading = false;
				});
		},
		/**
			* 跳转服务器组创建
		*/
		jumpToServerGroupAdd() {
			this.isAddServer = true;
		},

		// 跳转到负载均衡实例详情页
		jumpToUp() {
			this.$router.push({
				path: '/lb/list',
				query: {
					region: this.region
				}
			});
		},
		// 负载均衡操作
		selectInstanceOps() {
		},
		copyToClipboard() {
			this.copyHover = true;
		},
		// 切换tab卡时，切换背景颜色
		handleTabClick() {
			this.darkLoaded = this.activeTabName !== 'baseInfo';
			// 切换tab时 初始化pageSize&pageNumber
			this.pageSize = 20;
			this.currentPage = 1;
			this.getDifferentDataByTab();
		},

		// 根据当前选择的tab页，请求不同的数据
		getDifferentDataByTab() {
			this.getSlbDetail();
			switch (this.activeTabName) {
				case 'baseInfo':
					this.getRegions();
					break;
				case 'listenerList':
					this.getListenerListDataOfSlb();
					break;
				case 'defaultServerGroup': {
					const params = {
						loadBalancerId: this.$route.query.loadBalancerId,
						serverGroupId: this.$route.query.serverGroupIds
					};
					this.refreshGroupList(params);
					break;
				}
				default:
			}
		},
		/**
			 * 切换每一页多少条
			 * 同时将当前页置为1
			 * @param val
			 */
		handleSizeChange(val) {
			this.currentPage = 1;
			this.pageSize = val;
			this.getDifferentDataByTab('refresh');
		},
		// 切换当前页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getDifferentDataByTab();
		},
		/** *******************监听器相关 START******************* */
		/**
		 **@disc: 监听器操作
		 **@params: operatesCase：什么操作；row：当前行
		 */
		selectOps(operatesCase, row) {
			if (operatesCase === ListenerOperationConstant.DELETE) {
				this.deleteListenerVisible = true;
				this.deleteListenerData = row;
			}
			row.region = this.region;
			operations(operatesCase, this, row, 'list');
		},
		/**
		 **@disc: 跳转到创建监听器页面
		 */
		jumpToListenerCreate() {
			this.$router.push({
				name: 'ListenerEdit',
				query: {
					region: this.region,
					type: 'create',
					loadBalancerId: this.loadBalancerId,
					listenerCount: this.listenerCount,
					listenerProtocolType: this.listenerProtocolType,
				}
			});
		},

		handleCommand(command, row) {
			if (command === "opened") {
				this.selectOps(this.OperationConstant.OPEN, row)
			} else if (command === "closed") {
				this.selectOps(this.OperationConstant.CLOSE, row)
			} else if (command === "sni") {
				this.jumpToListenerDetail(row.listenerId, 'sni')
			} else if (command === "delete") {
				this.selectOps(this.OperationConstant.DELETE, row)
			}
		},
		/**
		 **@disc: 获取当前负载均衡实例下的监听器列表接口
		 */
		getListenerListDataOfSlb() {
			this.listenerRefreshLoading = true;
			const param = {
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
				loadBalancerId: this.loadBalancerId,
				region: this.region
			};
			Ajax.get('/api/cps/listListeners', param)
				.then((res) => {
					this.listenerListData = res.data.listeners;
					// 格式化字段
					for (const item of this.listenerListData) {
						// 状态
						item.statusName = RunningOrStoppedConstant[item.status.toUpperCase()];
						// 调度算法
						item.algorithmName = AlgorithmNameMapConstant[item.algorithm.toUpperCase()];
						// 会话保持
						item.stickySessionName = OnOrOffMapConstant[item.stickySession.toUpperCase()];
						// 健康检查
						item.healthCheckName = OnOrOffMapConstant[item.healthCheck.toUpperCase()];
					}
					this.total = res.data.totalCount;
					// 默认值11代表4层和7层协议
					this.listenerProtocolType = this.listenerListData.reduce((pre, cur) => {
						return cur.protocolType
					}, "11");
					this.listenerCount = res.data.totalCount;
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
					this.listenerRefreshLoading = false;
				});
		},
		/**
		 **@disc: 跳转到监听器详情
		 **@params: id：监听器ID
		 */
		jumpToListenerDetail(id, tabName = "source") {
			this.$router.push({
				path: '/lb/listener/detail',
				query: {
					id,
					region: this.region,
					activeTab: tabName
				}
			});
		},
		/**
		 **@disc: 删除lb跳回列表页
		 */
		goBack() {
			this.$router.push({
				path: '/lb/list'
			});
		},
		/**
		 **@disc: 监听器刷新按钮
		 */
		updateListenerList() {
			this.currentPage = 1;
			// this.pageSize = 20;
			this.getListenerListDataOfSlb();
		},
		/**
		 **@disc: 打开当前页的服务器组Tab
		 */
		openServerGroupTab() {
			this.activeTabName = 'defaultServerGroup';
		},
		// 同步绑定资源子组件传出来的dialog是否展示
		syncBindDialog(data) {
			this.deleteListenerVisible = data;
		},
		/** *******************监听器相关 END******************* */
	}
};
</script>

<style lang="scss">
@import '../../../assets/scss/paginationCommon.scss';
@import "~@/assets/scss/detailCommon.scss";
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/slb/detail/Detail.vue